import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/library/workflows/$workflowId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/library/workflows/$workflowId/canvas',
      params: { workflowId: params.workflowId },
    })
  },
})
